export class PackageConsumptionHistoryRequestDTO {
  boatId: number;
  boatNome: string;
  customerId: number;
  customerName: string;
  packageId: number;
  packageName: string;

  constructor() {
    this.boatId = 0;
    this.boatNome = '';
    this.customerId = 0;
    this.customerName = '';
    this.packageId = 0;
    this.packageName = '';
  }
}